import { z } from "zod";

export const loginSchema = z.object({
  username: z.string().min(1, "Vyplň přihlašovací jméno").max(255),
  password: z.string().min(1, "Vyplň heslo").max(128),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const registerSchema = z
  .object({
    username: z.string().min(1, "Vyplň přihlašovací jméno").max(255),
    password: z.string().min(8, "Heslo musí mít alespoň 8 znaků").max(128),
    password2: z.string(),
  })
  .refine((d) => d.password === d.password2, {
    message: "Hesla se neshodují",
    path: ["password2"],
  });
export type RegisterInput = z.infer<typeof registerSchema>;
